import { render, staticRenderFns } from "./instagram-timeline.vue?vue&type=template&id=b01b288c&scoped=true"
import script from "./instagram-timeline.vue?vue&type=script&lang=ts"
export * from "./instagram-timeline.vue?vue&type=script&lang=ts"
import style0 from "./instagram-timeline.vue?vue&type=style&index=0&id=b01b288c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b288c",
  null
  
)

export default component.exports